import * as THREE from 'three'

/**
 * Material that outputs world-space position as RGB color.
 * Used to compute noise in world space for the dither shader.
 */
export const WorldPosMaterial = new THREE.ShaderMaterial({
    vertexShader: /* glsl */`
        varying vec3 vWorldPos;
        void main() {
            vWorldPos = (modelMatrix * vec4(position, 1.0)).xyz;
            gl_Position = projectionMatrix * viewMatrix * vec4(vWorldPos, 1.0);
        }
    `,
    fragmentShader: /* glsl */`
        varying vec3 vWorldPos;
        void main() {
            // Encode world position - offset and scale to fit in 0-1 range
            // Assuming model is roughly within -5..5 range
            vec3 encoded = vWorldPos * 0.1 + 0.5;
            gl_FragColor = vec4(encoded, 1.0);
        }
    `,
})
